import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Displays detailed image compliance information in an expandable row
 */
const ImageComplianceDetails = ({ report }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 3, bgcolor: 'grey.50' }}>
      <Typography variant="h6" gutterBottom>
        {t('operationalReports.imageCompliance.title', { defaultValue: 'Image Compliance' })}
      </Typography>
      <Typography color="text.secondary">
        {t('operationalReports.imageCompliance.comingSoon', {
          defaultValue: 'Image compliance details will be displayed here.',
        })}
      </Typography>
    </Box>
  );
};

export default ImageComplianceDetails;
